<mat-sidenav-container autosize fullscreen>
  <mat-sidenav
    #sideNav
    role="navigation"
    class="sidenav"
    (click)="sideNav.close()"
  >
    <ng-container
      *ngTemplateOutlet="navList; context: { $implicit: 'column' }"
    ></ng-container>
  </mat-sidenav>

  <mat-sidenav-content role="main">
    <mat-toolbar color="warn">
      <div class="menu-container">
        <button mat-icon-button (click)="sideNav.open('mouse')">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      <ng-container
        *ngTemplateOutlet="navList; context: { $implicit: 'row' }"
      ></ng-container>
    </mat-toolbar>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #navList let-layout>
  <ft-navigation-bar class="nav-bar" [layout]="layout"></ft-navigation-bar>
  <section
    class="settings-wrapper"
    [class.settings-wrapper--row]="layout === 'row'"
  >
    <ft-settings-bar
      class="settings"
      [class.toolbar]="layout === 'row'"
      [isLoggedIn]="isLoggedIn"
      [isLoggedOut]="isLoggedOut"
      [isDarkMode]="isDarkMode"
      [photoUrl]="photoUrl"
      (loggedOutChange)="logOut()"
      (darkModeChanged)="toggleDarkMode()"
    ></ft-settings-bar>
  </section>
</ng-template>
